import api from "../config/api";

export const fetchAllVisitingTime = async () => {
  const res = await api.get("/visitingTime/");
  return res.data.data;
};

export const fetchVisitingTimeById = async (id) => {
  const res = await api.get(`/visitingTime/?id=${id}`);
  return res.data.data;
};

export const saveVisitingTime = async ({ adId, visitingTimes }) => {
  const res = await api.post(
    "/visitingTime/",
    { adId, visitingTimes },   
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return res.data;
};


export const fetchVisitingTimeByAdId = async (adId) => {
  const res = await api.get(`/visitingTime/?adId=${adId}`);
  return res.data.data;
};

export const deleteVisitingTime = async (id) => {
  const res = await api.delete(`/visitingTime/?id=${id}`);
  return res.data;
};

export const deleteVisitingTimeByAdId = async (adId) => {
  const res = await api.delete(`/visitingTime/?adId=${adId}`);
  return res.data;
};
